import { FunctionComponent } from 'react'
import EngagementAnalysis from '@/components/kol/detail/engagement-analyses/engagement-analysis'
import PostFrequencyAnalysis from '@/components/kol/detail/engagement-analyses/post-frequency-analysis'
import PublicTimeAnalysis from '@/components/kol/detail/engagement-analyses/public-time-analysis'
import ViewAnalysis from '@/components/kol/detail/engagement-analyses/view-analysis'
import { statisticPlatformSupport } from '@/constants/kol-detail/statistic-platform-support'
import { KolDetailDuration } from '@/hooks/use-authorization/routes'
import useIsPublicDetailPage from '@/hooks/use-is-public-detail-page'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import { Platform } from '@/utils/convert-platform'

interface EngagementAnalysesProps {
  kolInfo?: KolSchemaModel
  platform: Platform
  isKolInfoLocked: boolean
  duration: KolDetailDuration
  showMockData?: boolean
  isFetchingKolInfo: boolean
}

const EngagementAnalyses: FunctionComponent<EngagementAnalysesProps> = ({
  kolInfo,
  platform,
  isKolInfoLocked,
  duration,
  showMockData,
  isFetchingKolInfo,
}) => {
  const isPublicKolDetailPage = useIsPublicDetailPage()

  return (
    <>
      <EngagementAnalysis
        duration={duration}
        isFetchingKolInfo={isFetchingKolInfo}
        isKolInfoLocked={isKolInfoLocked}
        isPublicKolDetailPage={isPublicKolDetailPage}
        kolInfo={kolInfo}
        platform={platform}
        showMockData={showMockData}
      />
      {statisticPlatformSupport.viewAnalysis.includes(platform.shortcode) && (
        <ViewAnalysis
          duration={duration}
          isFetchingKolInfo={isFetchingKolInfo}
          isKolInfoLocked={isKolInfoLocked}
          isPublicKolDetailPage={isPublicKolDetailPage}
          kolInfo={kolInfo}
          platform={platform}
          showMockData={showMockData}
        />
      )}
      <PostFrequencyAnalysis
        duration={duration}
        isFetchingKolInfo={isFetchingKolInfo}
        isKolInfoLocked={isKolInfoLocked}
        isPublicPage={isPublicKolDetailPage}
        kolInfo={kolInfo}
        platform={platform}
        showMockData={showMockData}
      />
      <PublicTimeAnalysis
        duration={duration}
        isFetchingKolInfo={isFetchingKolInfo}
        isKolInfoLocked={isKolInfoLocked}
        isPublicPage={isPublicKolDetailPage}
        kolInfo={kolInfo}
        platform={platform}
        showMockData={showMockData}
      />
    </>
  )
}

export default EngagementAnalyses
